import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { COMPANY as DEFAULT_COMPANY, SERVICES as DEFAULT_SERVICES, FAQS as DEFAULT_FAQS } from './seo';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Defaults editorialmente sicuri se DB vuoto
export const DEFAULT_CONTENT = {
  hero: {
    badge: `Impresa Edile dal ${DEFAULT_COMPANY.foundingYear} · Calcinato (BS)`,
    title_line1: 'Costruiamo.',
    title_line2: 'Ristrutturiamo.',
    title_line3: 'Manteniamo nel tempo.',
    subtitle: "EDIL CIMA S.R.L. è l'impresa edile di riferimento in provincia di Brescia per nuove costruzioni, ristrutturazioni complete, rifacimento tetti, piscine e manutenzioni.",
    cta_primary: 'Richiedi Preventivo Gratuito',
    background_image: 'https://impresaedilecima.it/wp-content/uploads/2023/10/IMG_4196.jpg',
    video_url: '',
    stats: [
      { value: 'auto', label: 'Anni di esperienza' },  // 'auto' = calcolato da foundingYear
      { value: '100%', label: 'Lavori certificati' },
      { value: '500+', label: 'Cantieri completati' },
    ],
  },
  chi_siamo: {
    titolo: 'Chi siamo',
    paragrafo: '',  // se vuoto, ChiSiamo usa il suo testo originale
    foto: '',
  },
  company: DEFAULT_COMPANY,  // contatti / azienda
  servizi: DEFAULT_SERVICES,
  faqs: DEFAULT_FAQS,
  galleria: [], // array di {url, alt}
};

const LandingContentContext = createContext({ content: DEFAULT_CONTENT, loading: true });

/** Deep merge: i campi del CMS sovrascrivono i defaults; gli array vengono sostituiti per intero se non vuoti. */
function deepMerge(defaults, override) {
  if (override == null) return defaults;
  if (Array.isArray(override)) return override.length > 0 ? override : defaults;
  if (typeof override !== 'object') return override;
  const out = { ...defaults };
  for (const k of Object.keys(override)) {
    out[k] = deepMerge(defaults?.[k], override[k]);
  }
  return out;
}

export function LandingContentProvider({ children }) {
  const [raw, setRaw] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios.get(`${BACKEND}/api/public/landing-content`, { timeout: 8000 })
      .then(r => { if (mounted) setRaw(r.data || {}); })
      .catch(() => { if (mounted) setRaw({}); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  const content = useMemo(() => deepMerge(DEFAULT_CONTENT, raw || {}), [raw]);
  const value = useMemo(() => ({ content, loading }), [content, loading]);

  return <LandingContentContext.Provider value={value}>{children}</LandingContentContext.Provider>;
}

export function useLandingContent() {
  return useContext(LandingContentContext);
}

/** Helper per risolvere un URL immagine relativo (es. /uploads/...) al backend. */
export function resolveImageUrl(url) {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
  if (url.startsWith('/')) return `${BACKEND}${url}`;
  return url;
}
